import type {
    ReservationStore,
    ReservationStoreBase,
} from '~/features/product-details/components/ReservationDrawer/types';

// We keep only the store fields the reservation flow actually uses. SFCC stores are quite large,
// so this keeps the Zustand state easier to reason about.
export const mapStoreToReservationStore = (
    store: ReservationStoreBase,
    fields?: Partial<
        Pick<ReservationStore, 'closedLabel' | 'openLabel' | 'labelStoreHoursText' | 'storeIsOpen'>
    >,
): ReservationStore => ({
    id: store.id,
    storeId: store.storeId,
    name: store.name,
    address1: store.address1,
    address2: store.address2,
    city: store.city,
    phone: store.phone,
    postalCode: store.postalCode,
    c_openingHours: store.c_openingHours,
    c_openingStatusToday: store.c_openingStatusToday,
    c_storeClosedReason: store.c_storeClosedReason,
    c_clickReserveEnabled: store.c_clickReserveEnabled,
    c_weight: store.c_weight,
    c_stock_level: store.c_stock_level,
    c_stock_level_clickreserve: store.c_stock_level_clickreserve,
    ...fields,
});
